import React from "react";
import getGoogleMapsLink from "./../../utilities/maps";
import { formatDateString } from "../../utilities/datesFormatter";

export const linkToGoogleMaps = (tableInfo, event) => {
  if (tableInfo && tableInfo.column) {
    let ubicacion;
    switch (tableInfo.column.id) {
      case "Mapa":
        ubicacion = tableInfo.original;
        window.open(
          getGoogleMapsLink(ubicacion.Latitud, ubicacion.Longitud, "_blank")
        );
        break;
      default:
        break;
    }
  }
};

export const buildPerformanceReportColumns = (lang, currency, volumeUnit) => {
  const performanceReportColumns = [
    {
      Header: lang.Combustible,
      accessor: "Concepto"
    },
    {
      Header: lang.Valor,
      accessor: "Valor"
    },
    {
      Header: `${lang.Volumen} (${volumeUnit}s)`,
      accessor: "Volumen"
    },
    {
      Header: `${lang.Costo} (${currency})`,
      accessor: "Costo",
      Cell: props => (
        <span className="cost">{`$${props.value.toFixed(2)}`}</span>
      )
    }
  ];

  return performanceReportColumns;
};

export const buildEventsTableColumns = (lang, currency, volumeUnit) => {
  const eventsColumns = [
    {
      Header: lang.Evento,
      accessor: "ImagenUrl",
      Cell: props => <img src={props.value} alt="" className="event-icon" />,
      filterable: false
    },
    {
      Header: `${lang.Volumen} (${volumeUnit}s)`,
      accessor: "Volumen"
    },
    {
      Header: `${lang.Costo} (${currency})`,
      accessor: "Costo",
      Cell: props => (
        <span className="cost">{`$${props.value.toFixed(2)}`}</span>
      )
    },
    {
      Header: lang.Fecha,
      accessor: "Fecha",
      Cell: props => <span>{formatDateString(props.value)}</span>
    },
    // {
    //   Header: lang.Direccion,
    //   accessor: "Direccion"
    // },
    // {
    //   Header: lang.Ciudad,
    //   accessor: "Ciudad"
    // },
    {
      Header: lang.Mapa,
      accessor: "Mapa",
      Cell: props => (
        <span className="link" onClick={linkToGoogleMaps.bind(null, props)}>
          {lang.Mapa}
        </span>
      )
    }
  ];

  return eventsColumns;
};

export const buildHistoryColumns = (lang, distanceUnit, volumeUnit) => {
  const historyColumns = [
    {
      Header: lang.Fecha,
      accessor: "Fecha",
      Cell: props => <span>{formatDateString(props.value)}</span>
    },
    {
      Header: `${lang.Velocidad} (${distanceUnit}/h)`,
      accessor: "Velocidad"
    },
    // {
    //   Header: lang.Direccion,
    //   accessor: "Direccion"
    // },
    // {
    //   Header: lang.Ciudad,
    //   accessor: "Ciudad"
    // },
    {
      Header: lang.Evento,
      accessor: "Evento",
      Cell: props => <span>{lang[`Event${props.value}`]}</span>
    },

    {
      Header: `${lang.Volumen} (${volumeUnit})`,
      accessor: "Volumen"
    },
    {
      Header: lang.Mapa,
      accessor: "Mapa",
      Cell: props => (
        <span className="link" onClick={linkToGoogleMaps.bind(null, props)}>
          {lang.Mapa}
        </span>
      )
    }
  ];

  return historyColumns;
};

export const buildInitialFinalFuelColumns = (lang, currency, volumeUnit) => {
  const initialFinalFuelColumns = [
    {
      Header: lang.Unidad,
      accessor: "Unidad"
    },
    {
      Header: `${lang.Volumen} (${volumeUnit})`,
      accessor: "Volumen"
    },
    {
      Header: `${lang.Costo} (${currency})`,
      accessor: "Costo",
      Cell: props => <span>{`$${props.value.toFixed(2)}`}</span>
    }
  ];

  return initialFinalFuelColumns;
};

export const buildChargesDischargesColumns = (lang, currency, volumeUnit) => {
  const chargesDischargesColumns = [
    {
      Header: lang.Unidad,
      accessor: "Unidad"
    },
    {
      Header: lang.Cantidad,
      accessor: "Valor"
    },
    {
      Header: `${lang.Volumen} (${volumeUnit})`,
      accessor: "Volumen"
    },
    {
      Header: `${lang.Costo} (${currency})`,
      accessor: "Costo",
      Cell: props => <span>{`$${props.value.toFixed(2)}`}</span>
    }
  ];

  return chargesDischargesColumns;
};

export const buildIddleColumns = (lang, currency, volumeUnit) => {
  const iddleColumns = [
    {
      Header: lang.Unidad,
      accessor: "Unidad"
    },
    {
      Header: lang.Tiempo,
      accessor: "Valor"
    },
    {
      Header: `${lang.Volumen} (${volumeUnit})`,
      accessor: "Volumen"
    },
    {
      Header: `${lang.Costo} (${currency})`,
      accessor: "Costo",
      Cell: props => <span>{`$${props.value.toFixed(2)}`}</span>
    }
  ];

  return iddleColumns;
};

export const buildConsumedFuelColumns = (lang, currency, volumeUnit) => {
  const consumedColumns = [
    {
      Header: lang.Unidad,
      accessor: "Unidad"
    },
    {
      Header: lang.Distancia,
      accessor: "Valor"
    },
    {
      Header: `${lang.Volumen} (${currency})`,
      accessor: "Volumen"
    },
    {
      Header: `${lang.Costo} (${currency})`,
      accessor: "Costo",
      Cell: props => <span>{`$${props.value.toFixed(2)}`}</span>
    }
  ];

  return consumedColumns;
};

export const buildSummaryBehaviorColumns = lang => {
  const summaryBehaviorColumns = [
    {
      Header: lang.Unidad,
      accessor: "Unidad"
    },
    {
      Header: lang.TipoUnidad,
      accessor: "Tipo"
    },
    {
      Header: lang.VelocidadMaxima,
      accessor: "VelocidadMaxima"
    },
    {
      Header: lang.TiempoMovimiento,
      accessor: "TiempoMovimiento"
    },
    {
      Header: lang.TiempoMuerto,
      accessor: "TiempoMuerto"
    },
    {
      Header: lang.RendimientoBruto,
      accessor: "RendimientoBruto"
    },
    {
      Header: lang.RendimientoEfectivo,
      accessor: "RendimientoEfectivo"
    }
  ];

  return summaryBehaviorColumns;
};



// WEBPACK FOOTER //
// ./src/containers/Fuel/builders.js